import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-outlined p-4"
}
const _hoisted_2 = {
  key: 0,
  class: "mb-4 mt-4"
}
const _hoisted_3 = { class: "form-error-text" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = {
  for: "name",
  class: "form-label"
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "form-error-text" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = {
  for: "email",
  class: "form-label"
}
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "form-error-text" }
const _hoisted_12 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_13 = {
  for: "memo1",
  class: "form-label"
}
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "form-error-text" }
const _hoisted_16 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_17 = {
  for: "memo2",
  class: "form-label"
}
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "form-error-text" }
const _hoisted_20 = { class: "pt-4 pb-2 flex items-center justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_alert = _resolveComponent("base-alert")!
  const _component_base_form_select = _resolveComponent("base-form-select")!
  const _component_base_form_submit = _resolveComponent("base-form-submit")!

  return (_ctx.seminarDetails)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_base_alert, { class: "mb-4" }),
        _createElementVNode("form", {
          onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
        }, [
          (_ctx.seminarStatus && _ctx.seminarDetails.seminar_category_id === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[6] || (_cache[6] = _createElementVNode("label", {
                  for: "status",
                  class: "form-label"
                }, " 参加方法 ", -1)),
                _createVNode(_component_base_form_select, {
                  class: "mb-1",
                  selectedVal: _ctx.seminar_status_id,
                  "onUpdate:selectedVal": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.seminar_status_id) = $event)),
                  options: _ctx.seminarStatus
                }, null, 8, ["selectedVal", "options"]),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.errors['seminar_status_id']), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.t('word.name')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
              id: "name",
              name: "name",
              type: "text",
              placeholder: _ctx.t('word.name'),
              class: _normalizeClass(`form-input mb-1 ${_ctx.errors['name'] ? 'border-red-500' : ''}`)
            }, null, 10, _hoisted_6), [
              [_vModelText, _ctx.name]
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.errors['name']), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t('word.email')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
              id: "email",
              name: "email",
              type: "email",
              placeholder: _ctx.t('word.email'),
              class: _normalizeClass(`form-input mb-1 ${_ctx.errors['email'] ? 'border-red-500' : ''}`)
            }, null, 10, _hoisted_10), [
              [_vModelText, _ctx.email]
            ]),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.errors['email']), 1)
          ]),
          (_ctx.seminarDetails.memo1_title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.seminarDetails.memo1_title), 1),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.memo1) = $event)),
                  id: "memo1",
                  name: "memo1",
                  placeholder: _ctx.seminarDetails.memo1_title,
                  class: _normalizeClass(`form-input mb-1 ${_ctx.errors['memo1'] ? 'border-red-500' : ''}`),
                  rows: 5
                }, null, 10, _hoisted_14), [
                  [_vModelText, _ctx.memo1]
                ]),
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.errors['memo1']), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.seminarDetails.memo2_title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.seminarDetails.memo2_title), 1),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.memo2) = $event)),
                  id: "memo2",
                  name: "memo2",
                  placeholder: _ctx.seminarDetails.memo2_title,
                  class: _normalizeClass(`form-input mb-1 ${_ctx.errors['memo2'] ? 'border-red-500' : ''}`),
                  rows: 5
                }, null, 10, _hoisted_18), [
                  [_vModelText, _ctx.memo2]
                ]),
                _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.errors['memo2']), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_base_form_submit, {
              disabled: _ctx.btnDisabled,
              text: _ctx.t('seminar_details.apply.submit')
            }, null, 8, ["disabled", "text"])
          ])
        ], 32)
      ]))
    : _createCommentVNode("", true)
}